import { remoteJSON } from './remote';

export const login = async (credentials: {
	email: string;
	password: string;
	recaptcha_token?: string;
	platform: string;
}) => {
	const result = (await remoteJSON('/auth', { body: JSON.stringify(credentials), method: 'POST' })) as LoginResponse;

	return result;
};

export const logout = async () => {
	const result = (await remoteJSON('/auth', { method: 'DELETE' })) as APIMessageResponse;

	return result;
};

export const refreshToken = async () => {
	const result = (await remoteJSON('/auth/refresh', { method: 'POST' })) as LoginResponse;

	return result;
};
